import {api} from 'services/api';
import {ObjectId} from 'types/object-id';
import {IConclusion, IContact} from 'types/project';
import {ResponseData} from 'types/response-data';

const getProjectContacts = api.injectEndpoints({
  endpoints: builder => ({
    getProjectContacts: builder.query<Response, Request>({
      query: params => {
        return {
          method: 'GET',
          url: `projects/${params.id}/contacts`,
        };
      },
    }),
  }),
});

type Request = {
  id?: ObjectId;
};

type Response = ResponseData<Array<IContact>>;

export const {useGetProjectContactsQuery} = getProjectContacts;
